// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__JW6uu","paramInput":"JobSimulator_paramInput__1gNxW","input":"JobSimulator_input__1YsZW"};